import { useState, useEffect } from "react";
import { useLogin } from "../../login/context/LoginContext";

import { Text, Button, InputOTP, HelperText, Icon } from '@ui-component-library';

import { verifyCode } from "../../../api/services/login";
import { formattedPhoneNumber } from "../helpers";

export default function LoginCode() {
    const LoginContext = useLogin();

    const [code, setCode] = useState('');
    const [codeError, setCodeError] = useState(false);
    const [countdown, setCountdown] = useState(30);
    const [isValidating, setIsValidating] = useState(false);

    useEffect(() => {
        if (countdown <= 0) return;

        const timerId = setTimeout(() => {
            setCountdown(countdown - 1);
        }, 1000);

        return () => clearTimeout(timerId);
    }, [countdown]);

    useEffect(() => {
        if(LoginContext.errors?.resend_error && LoginContext.errors.resend_timer) {
            setCountdown(Number(LoginContext.errors.resend_timer))
        }
        if(LoginContext.errors?.code_error) {
            setCodeError(LoginContext.errors.code_error)
            LoginContext.setErrors(prev => ({...prev, code_error: undefined}))
        }
    }, [LoginContext.errors]);

    const checkCode = async (value) => {
        if (value === code || value.length !== 4) {
            return;
        }
        setCodeError(false);
        setIsValidating(true);
        setCode(value)

        const resp = await verifyCode(value, LoginContext.data.user_id, LoginContext.data.email);
        if (resp.ok) {
            setCodeError(false);
            if(!LoginContext.exists) {
                gtag('event', 'Registered', {});
                gtag('event', 'sign_up', { method: 'Site' });
                mixpanel.track("registration_success_fe", {form: 'login_form'})
            } else {
                gtag('event', 'login', { method: 'site' });
                mixpanel.track("login_success_fe", {login_method: resp.data.login_method})   
            }
            await LoginContext.onLogin(resp.data.user_id)
            //LoginContext.close(false)
            /*
            if(resp.data.bankid_enabled) {
                LoginContext.close(false)
            } else {
                LoginContext.setView('main')
            }*/

            return;
        } else {
            if(!LoginContext.exists) {
                mixpanel.track("registration_failure_fe", {form: 'login_form', errors: resp.error ?? "", error_type: resp.error ?? "", failed_attempts: resp.data.error_info.attempts ?? 0, login_method: resp.data.error_info?.login_method ?? "" })
            } else {
                mixpanel.track("login_failure_fe", {error_type: resp.error ?? "", failed_attempts: resp.data.error_info.attempts ?? 0, login_method: resp.data.error_info?.login_method ?? ""}
                )
            }
            setCodeError(resp.error)
        }
        setIsValidating(false);
    }

    const resendCode = async () => {
        const resp = await LoginContext.sendLoginRegister();
        if(resp.ok && resp.data.resend_timer) {
            setCountdown(resp.data.resend_timer);
        }
    }

    return <>
        <Text variant='subheaderSmallMedium' className='mb-2'>Ange engångskoden</Text>

        <Text variant='bodySmallRegular' className='text-pebble-500 mb-8'>Vi har skickat en 4-siffrig kod via {(LoginContext.data.mobile_phone_number && !LoginContext.data.email) ? 'sms' : 'e-post'} till <span className='text-charcoal-500 font-bold'>{(LoginContext.data.mobile_phone_number && !LoginContext.data.email) ? formattedPhoneNumber(LoginContext.data.mobile_phone_number) : LoginContext.data.email}</span></Text>

        <InputOTP inputMode='text' className='justify-center' value={code} onValueChange={(value) => checkCode(value)} isValid={!codeError} length={4} />
        {isValidating && <div className='flex w-auto items-center justify-center my-2'>
            <div className="size-4 border-2 border-charcoal-500 border-t-transparent border-solid rounded-full animate-spin" />
        </div>} 

        {(codeError && !isValidating) && <HelperText className='text-danger-500 fill-danger-500 justify-center mt-2' icon='ExclamationFilled' label={codeError} />}

        <div className='bg-white-300 rounded-md border-1 border-white-400 border-solid p-3 mt-3'>
            <HelperText icon='InfoFilled' label='Om du inte hittar koden efter några minuter, kolla din skräppost.' />
        </div>
        
        <Button variant='primary' onClick={resendCode} disabled={countdown > 0 || LoginContext.loading} className='mt-6' fullWidth>
            <Icon name='ResendSimple' className='fill-white-500' />{countdown > 0 ? `Skicka igen om ${countdown}s` : 'Skicka kod på nytt'}
        </Button>

        <Button variant='secondary' onClick={() => LoginContext.setView('start')} className='mt-3' fullWidth>Avbryt</Button>
    </>
}
